// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Y9Mg","left":"styles_left__2amTy","desktopActions":"styles_desktopActions__xYwqc","title":"styles_title__34Ypv"};